import { formatCurrency } from "@sellar-io/common";
import { twMerge } from "tailwind-merge";
import { Alert } from "../../../components/alert/Alert";

export const OrderRefundedAlert = ({
  refundAmount,
  className,
}: {
  className?: string;
  refundAmount: number;
}) => {
  return (
    <Alert
      className={twMerge(className)}
      message={`A total of ${formatCurrency(
        refundAmount,
      )} will be refunded to the payment card used to purchase in 5-10 business days.`}
      title={"Refund issued"}
      type={"information"}
    />
  );
};
